module.exports = __webpack_public_path__ + "img/brain-960w.32494307.jpg";